module.exports = __webpack_public_path__ + "img/pg5-article2-text1.392432ed.png";